export enum FROALA_FOCUS_ENUM {
  TITLE = 1,
  SUBTITLE = 2,
}
